import React, { useState } from "react";
import SignInScreen from "./SignInScreen";
import SignUpScreen from "./SignUpScreen";
import ForgotPasswordModal from "./ForgotPasswordModal";
import { AuthMode } from "../auth.types";

export default function AuthScreensContainer() {
  const [authMode, setAuthMode] = useState<AuthMode>("signin");

  const switchToSignUp = () => setAuthMode("signup");
  const switchToSignIn = () => setAuthMode("signin");
  const switchToForgotPassword = () => setAuthMode("forgot-password");

  if (authMode === "signup") {
    return <SignUpScreen onSwitchToSignIn={switchToSignIn} />;
  }

  if (authMode === "forgot-password") {
    return <ForgotPasswordModal onClose={switchToSignIn} />;
  }

  return (
    <SignInScreen
      onSwitchToSignUp={switchToSignUp}
      onSwitchToForgotPassword={switchToForgotPassword}
    />
  );
}
